export const SET_IMPORT_DIALOG = 'SET_IMPORT_DIALOG';
export const SET_LOADING = 'SET_LOADING';
export const FETCH_COURSE_LOG = 'FETCH_COURSE_LOG';
export const LOG_COURSE_LOG = 'LOG_COURSE_LOG';
export const SET_COURSE_LOG = 'SET_COURSE_LOG';
export const SET_ACTIVE_PROGRAM = 'SET_ACTIVE_PROGRAM';